import {
  Component,
  Input,
  OnChanges, SimpleChanges
} from '@angular/core'
import { NgForm } from '@angular/forms'
import { Observable } from 'rxjs'
import { BUCKET_URL } from 'src/app/_shared/utils/constants'
import { uuidv4 } from 'src/app/_shared/utils/uuidv4'
import Swal from 'sweetalert2'
import { IServiceOrder } from '../../interface'
import { ILoaders } from '../interface'
import { ServiceOrderService } from '../service-order.service'

@Component({
  selector: 'app-service-order-details-modal',
  templateUrl: './service-order-details-modal.component.html',
  styleUrls: ['./service-order-details-modal.component.scss'],
})
export class ServiceOrderDetailsModalComponent
  implements OnChanges {
  @Input()
  order: IServiceOrder

  points: { lat: number; lng: number }[]

  loaders$: Observable<Partial<ILoaders>> = this.serviceOrderState.loaders$
  soiltestingresults: File
  constructor(
    private serviceOrderState: ServiceOrderService
  ) {
  }

  ngOnInit() { }
  updateOrder() {
    const update = {
      status: this.order.status,
    }
    this.serviceOrderState.updateOrder(this.order.id, update)
  }

  completeOrder(form: NgForm) {
    this.serviceOrderState.completeOrder(this.order.id)
  }

  deleteOrder() {
    Swal.fire({
      title: 'Are you sure?',
      confirmButtonText: 'Yes',
      type: 'warning',
      text: 'you want to delete this order',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.serviceOrderState.deleteOrder(this.order.id, true)
      }
    })
  }

  uploadSoilTestingResults() {
    if (this.soiltestingresults) {
      const formData = new FormData()
      let name = `soil-test-${uuidv4()}`
      formData.append('results', this.soiltestingresults, name)
      this.serviceOrderState.uploadSoilTestingResults(this.order.id, formData)
      return
    }
    Swal.fire({
      title: 'Please select a file to upload',
      type: 'error',
      timer: 2000,
    })
  }

  public get statuses(): string[] {
    const defaultStatuses = ['new', 'COMPLETED', 'failed', 'cancelled']
    if (!defaultStatuses.includes(this.order.status)) {
      defaultStatuses.push(this.order.status)
    }
    return defaultStatuses
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.points = this.formatPoints()
  }

  formatPoints() {
    if (this.order.latitudes && this.order.longitudes) {
      const coordinates: { lat: number; lng: number }[] = []
      for (let index = 0; index < this.order.latitudes.length; index++) {
        const lat = this.order.latitudes[index]
        const lng = this.order.longitudes[index]
        coordinates.push({ lat, lng })
      }
      return coordinates
    } else if (this.order.gps_points && this.order.gps_points.length > 0) {
      const map = this.order.gps_points[0]
      return map.map((val) => {
        return {
          lat: val.Latitude,
          lng: val.Longitude,
        }
      })
    }
    return []
  }

  public get isDisabled(): boolean {
    return this.order.status.toUpperCase() === 'COMPLETED'
      || this.order.status.toUpperCase() === 'PAID'
      || this.order.status.toUpperCase() === 'COMPLETE'
  }

  public get isSoilTestingOrder() {
    return this.order.type === 'soil_test' || (this.order.service_name.includes('soil') && this.order.service_name.includes('test'))
  }

  public get isNewOrder() {
    return this.order.status.toLowerCase() === 'new' || (this.order.status.toLowerCase() === 'paid' && this.order.payment.toLowerCase() === 'credits')
  }

  public uploadOrderResults($event: any) {
    const file = $event.target.files[0];
    if (file) {
      // validate file size is less than 2mb
      if (file.size > 2097152) {
        Swal.fire({
          title: 'File size is too large',
          type: 'error',
        })
        return
      }
      // validate that file is pdf
      if (file.type !== 'application/pdf') {
        Swal.fire({
          title: 'File is not a pdf',
          type: 'error',
        })
        return
      }
      const formData = new FormData()
      let name = `order-results-${uuidv4()}.pdf`
      formData.append('results', file, name)
      this.serviceOrderState.uploadOrderResults(this.order.id, formData).subscribe(val=>{
        // clear the file input
        $event.target.value = ''
      })
      return
    }
    Swal.fire({
      title: 'Please select a file to upload',
      type: 'error',
      timer: 2000,
    })
  }

  public get reportUrl() {
    return `${BUCKET_URL}${this.order.report[this.order.report.type]}`
  }
}
